module.exports = __webpack_public_path__ + "img/truck-ds-alt.a5f913c7.svg";